<template>
  <div v-if="customerDailyInfo" class="container mt-4">
    <div class="quick-list">

      <div class="quick-item">   
        <i :class="customerDailyInfo.unpaidInvoice ? 'text-danger ' : 'text-dark'" class="icon font-size-16 fas fa-file-invoice"></i>
        <a class="label" href="/invoices/list?type=0"  
             :class="customerDailyInfo.unpaidInvoice ? 'text-danger ' : 'text-dark'"  style="cursor: pointer;">Factures impayées
            
            </a>
        <span class="count" 
        :class="customerDailyInfo.unpaidInvoice ? 'text-danger ' : 'text-dark'" >{{ customerDailyInfo.unpaidInvoice }}</span>
      </div>  

      <!-- Commandes en cours -->
      <div class="quick-item">   
        <i class="icon fas fa-shopping-cart"></i>
        <a class="label" href="/orders/list" style="cursor: pointer;">Commandes en cours</a>
        <span class="count">{{ customerDailyInfo.orderCount }}</span>
      </div>

      <!-- Offres expirant bientôt -->
      <div class="quick-item">
        <i class="icon fas fa-hourglass-half"></i>
        <a class="label" href="/promotions/list" style="cursor: pointer;">Offres expirant bientôt</a>
        <span class="count">{{ customerDailyInfo.promotionExpiredSoon }}</span>
      </div>

      <!-- Produits à nouveau disponibles -->
      <div class="quick-item">
        <i class="icon fas fa-box-open"></i>
        <span class="label">Produits à nouveau disponibles</span>
        <span class="count">{{ customerDailyInfo.nowAvailableItems }}</span>
      </div>

      <!-- Messages LGP -->
      <div class="quick-item" :class="customerDailyInfo.messageCount ? 'text-danger' : 'text-dark'">
        <i class="message-icon fas fa-envelope"></i>
          <router-link
            to="/messages"
            class="message-label" :class="customerDailyInfo.messageCount ? 'text-danger' : 'text-dark'"
            style="cursor: pointer;"
          >
            Messages LGP
          </router-link>
        <span class="message-count">{{customerDailyInfo.messageCount}}</span>
      </div>

    </div>
  </div>
</template>

<script>
import OrdersApi from "@/services/orders-api";

export default {
  name: "QuickShortcuts",
  data() {
    return {
      customerDailyInfo:null,
      isCustomerDailyInfoBusy:false,
    };
  },

  
  mounted() {
    this.getCustomerDailyInfo()
  },

  methods:{
    getCustomerDailyInfo(){
      this.isCustomerDailyInfoBusy = true;
      OrdersApi.getCustomerDailyInfo().then((result) => {
        this.customerDailyInfo = result;
        }).finally(() => {
          this.isCustomerDailyInfoBusy = false;
        })
    },
  }
};
</script>


<style scoped>
.quick-list {
  background: #fff;
  border-radius: 6px;
}

.quick-item {
  display: flex;
  align-items: center;
  padding: 5px 0;
  font-size: 14px;
}

.quick-item:last-child {
  border-bottom: none;
}

.icon {
  width: 30px;
  text-align: center;
  color: #555;
}

.label {
  flex: 1;
  color: #333;
}

.count {
  font-weight: bold;
  color: #000;
}

.message-icon {
  width: 30px;
  text-align: center;
}

.message-label {
  flex: 1;
}

.message-count {
  font-weight: bold;
}
</style>